import { useEffect, useState } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Col, Row } from 'react-bootstrap';
import LabelEditDialog from './LabelEditDialog/LabelEditDialog';

function LabelsDataTable() {

  // #region var and consts
  
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editDialogIsVisible, setEditDialogIsVisible] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(null);
  const [globalFilter, setGlobalFilter] = useState('');
  const [filters, setFilters] = useState({
    'global': {
      value: null,
      matchMode: FilterMatchMode.CONTAINS
    },
    "description": {
      operator: FilterOperator.AND,
      constraints: [{
        value: null,
        matchMode:
          FilterMatchMode.CONTAINS
      }]
    }
  });

  // #endregion

  // #region methods

  const getLabels = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/label/findAll`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          setLabels(data.responseObject);
        } else {
          console.warn('LabelsDataTable: getLabels: error: data:', data);
        }
        setLoading(false);
      });
  };

  // #endregion 

  // #region events

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    const _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilter(value);
  }

  const onNewClick = () => {
    setSelectedLabel(null);
    setEditDialogIsVisible(true);
  };

  const onProfileSaved = () => {
    setEditDialogIsVisible(false);
    getLabels();
  };

  const onEditClick = (profile) => {
    setSelectedLabel(profile);
    setEditDialogIsVisible(true);
  };

  // #endregion

  // #region templates

  const headerTemplate = (
    <>
      <Row>
        <Col md={8}>
          <span className="p-input-icon-left">
            <i className="pi pi-filter" />
            <InputText
              placeholder="Filtrar"
              value={globalFilter}
              onChange={onGlobalFilterChange} />
          </span>
        </Col>
        <Col md={4}>
          <Button
            label="Nueva"
            className="p-button-raised p-button-sm float-end"
            onClick={onNewClick}
          />
        </Col>
      </Row>
    </>
  );

  const dataTableActionsTemplate = (label) => {
    return (
      <>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-primary p-button-text mr-2"
          onClick={() => onEditClick(label)} />
      </>
    );
  };

  const dataTableTemplate = (
    <>
      <div className="card">
        <DataTable
          className=""
          showGridlines
          stripedRows
          size="small"
          responsiveLayout="scroll"
          emptyMessage="No se encontraron etiquetas"
          value={labels}
          header={headerTemplate}
          filters={filters}
          filterDisplay="menu"
          loading={loading}
          globalFilterFields={[
            'description'
          ]}>
          <Column
            className='app-w-50-px text-center'
            body={dataTableActionsTemplate}
            exportable={false} />
          <Column
            field="description"
            header="Etiqueta"
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por etiqueta"
            sortable />
        </DataTable>
      </div>
    </>
  );

  // #endregion

  useEffect(() => {
    getLabels();
  }, []);

  return (
    <>
      <article>
        {dataTableTemplate}
        <LabelEditDialog
          visible={editDialogIsVisible}
          onHide={() => setEditDialogIsVisible(false)}
          onLabelSaved={onProfileSaved}
          label={selectedLabel}
        />
      </article>
    </>
  );
}

export default LabelsDataTable;